// localhost 动态改写(spec 260723 v4.2 ③):软件工厂生成的 service_url 一律是
// http://127.0.0.1:<port>/ ——网络层其实是通的(端口映射 0.0.0.0),坏的只是
// URL 字符串里的主机名。凡向用户展示 / 跳转的应用地址,把本机回环主机名替换
// 成「浏览器当前访问 OS 的主机名」:谁从哪个地址进 OS,就用哪个地址跳应用,
// 换 IP / 加域名 / 走 VPN 全部自适应。落库的 service_url 原样保留,不写死 IP。
const LOCAL_HOSTS = new Set(['127.0.0.1', 'localhost', '0.0.0.0']);

export function resolveServiceUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const parsed = new URL(url);
    if (LOCAL_HOSTS.has(parsed.hostname) && typeof window !== 'undefined') {
      parsed.hostname = window.location.hostname;
      return parsed.toString();
    }
    return url;
  } catch {
    return url; // 不是合法 URL 就原样返回,展示层自己兜底
  }
}
